import set from "@rill/set";
import rill from "rill";

import {
  acknowledgeAthlete,
  deleteGroup,
  getRoot,
  postCancelInvite,
  postInviteAthlete,
  postNewGroup,
  postResendInvite,
  postSeedDemo,
  postSortGroups,
  postUpdateGroup,
  postUpdateGroupForOrganizations,
} from "./athletes.controller.js";

const Athletes = (app) => {
  app.at(
    "/athletes/*",
    rill()
      .use(set("heading", ["Coaching", "Athletes"]))
      .setup((app) => {
        app
          .get("/", getRoot)
          .post("/invite-athlete", postInviteAthlete)
          .post("/cancel-invite", postCancelInvite)
          .post("/resend-invite", postResendInvite)
          .post("/new-group", postNewGroup)
          .post("/delete-group", deleteGroup)
          .post("/sort-groups", postSortGroups)
          .post("/update-group", postUpdateGroup)
          .post("/organization-update-group", postUpdateGroupForOrganizations)
          .post("/acknowledge-athlete", acknowledgeAthlete)
          .post("/seed-demo", postSeedDemo);
      })
  );
};

export default Athletes;
